import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import en from '~/services/i18n/en.json';
import es from '~/services/i18n/es.json';
import nl from '~/services/i18n/nl.json';
import fr from '~/services/i18n/fr.json';
import de from '~/services/i18n/de.json';
import cs from '~/services/i18n/cs.json';

export const defaultNS = 'translation';
export const resources = {
  en: {
    translation: en,
  },
  nl: {
    translation: nl,
  },
  es: {
    translation: es,
  },
  fr: {
    translation: fr,
  },
  de: {
    translation: de,
  },
  cs: {
    translation: cs,
  },
} as const;

export function configLocales() {
  i18n.use(initReactI18next).init({
    resources,
    ns: defaultNS,
    defaultNS,
    fallbackLng: 'en',
    returnEmptyString: false,
    interpolation: {
      escapeValue: false,
    },
    react: {
      transKeepBasicHtmlNodesFor: ['ol', 'li', 'ul', 'p'],
    },
  });
  return i18n;
}
